import React from 'react';

export default function TopBar() {
  return (
    <div style={s.bar}>
      <img src="/saksham_logo_dark.png" alt="Saksham Cloud" style={s.logo} />
    </div>
  );
}

const s = {
  bar: {
    position: 'fixed', 
    top: 0, 
    left: 248,  // Same as sidebar width
    right: 0, 
    height: 52, 
    zIndex: 100,
    background: '#ffffff', 
    borderBottom: '1px solid #e2e8f0',
    display: 'flex', 
    alignItems: 'center', 
    gap: 10,
    padding: '0 28px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
  },
  logo: { height: 81, objectFit: 'contain' },
  text: {
    fontSize: 15, 
    fontWeight: 700, 
    color: '#0f172a',
    letterSpacing: '-0.2px', 
    fontFamily: "'Inter','Segoe UI',sans-serif",
  },
};
